<div class="navbar-nav">
    <div class="progress-bar-table" [class.inactive]="step0">
        <div class="step step1" [class.active]="step1" [class.completed]="isStepComplete(1)">
            <a href="javascript:" (click)="gotoStart()">
            <div class="circle-container">
                <div class="outer-circle">
                    @if (isStepComplete(1)) {
                        <svg class="checkmark" aria-hidden="true" viewBox="0 0 448 512" width="14" height="14">
                            <path fill="currentColor" d="M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z"></path>
                        </svg>
                    } @else {
                        <span class="step-number">1</span>
                    }
                </div>
            </div>
            <div class="label">Start</div>
            </a>
            <div class="line" [class.completed]="isLineComplete(1)"></div>
        </div>
        <div class="step step2" [class.active]="step2" [class.completed]="isStepComplete(2)">
            <div class="circle-container">
                <div (click)="goToBoxStyles()" class="outer-circle">
                    @if (isStepComplete(2)) {
                        <svg class="checkmark" aria-hidden="true" viewBox="0 0 448 512" width="14" height="14">
                            <path fill="currentColor" d="M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z"></path>
                        </svg>
                    } @else {
                        <span class="step-number">2</span>
                    }
                </div>
            </div>
            <div class="label">Style</div>
            <div class="line" [class.completed]="isLineComplete(2)"></div>
        </div>
        <div class="step step3" [class.active]="step3" [class.completed]="isStepComplete(3)">
            <div class="circle-container">
                <div (click)="goToBoxOptions()" class="outer-circle">
                    @if (isStepComplete(3)) {
                        <svg class="checkmark" aria-hidden="true" viewBox="0 0 448 512" width="14" height="14">
                            <path fill="currentColor" d="M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z"></path>
                        </svg>
                    } @else {
                        <span class="step-number">3</span>
                    }
                </div>
            </div>
            <div class="label">Size & Specs</div>
            <div class="line" [class.completed]="isLineComplete(3)"></div>
        </div>
        <div class="step step4" [class.active]="step4" [class.completed]="isStepComplete(4)">
            <div class="circle-container">
                <div (click)="goToDesigner()" class="outer-circle">
                    @if (isStepComplete(4)) {
                        <svg class="checkmark" aria-hidden="true" viewBox="0 0 448 512" width="14" height="14">
                            <path fill="currentColor" d="M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z"></path>
                        </svg>
                    } @else {
                        <span class="step-number">4</span>
                    }
                </div>
            </div>
            <div class="label">Design</div>
            <div class="line" [class.completed]="isLineComplete(4)"></div>
        </div>
        <div class="step step5" [class.active]="step5" [class.completed]="isStepComplete(5)">
            <div class="circle-container">
                <div class="outer-circle">
                    @if (isStepComplete(5)) {
                        <svg class="checkmark" aria-hidden="true" viewBox="0 0 448 512" width="14" height="14">
                            <path fill="currentColor" d="M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z"></path>
                        </svg>
                    } @else {
                        <span class="step-number">5</span>
                    }
                </div>
            </div>
            <div class="label">Review</div>
            <div class="line" [class.completed]="isLineComplete(5)"></div>
        </div>
        <div class="step step6" [class.active]="step6" [class.completed]="isStepComplete(6)">
            <div class="circle-container">
                <div routerLink="/cart" class="outer-circle">
                    @if (isStepComplete(6)) {
                        <svg class="checkmark" aria-hidden="true" viewBox="0 0 448 512" width="14" height="14">
                            <path fill="currentColor" d="M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z"></path>
                        </svg>
                    } @else {
                        <span class="step-number">6</span>
                    }
                </div>
            </div>
            <div class="label">Checkout</div>
        </div>
    </div>
</div>
  <form name="back" #back ngNoForm [action]="state().referer" method="post">
    <input name="action" type="hidden" value="cancel" />
  </form>
